export default function PHP_include_once() {
  return (
    <div>
      <h1>PHP_include_once</h1>
    </div>
  );
}
